module.exports = __webpack_public_path__ + "static/media/LazyAz_android_1_preview.f9db6f5b.jpg";